export default __webpack_public_path__ + "static/media/yellow-dotted-pattern.5f2f5678.svg";